import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import Deposit from "../transactions/Deposit"
import LoginGlobal from "../data/LoginGlobal"

export default function RecoveryHour() {
  const data = promotionsData.find(
    (promo) => promo.title === "8PM Recovery Hour"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> 8PM Recovery Hour </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /{" "}
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> 8PM Recovery Hour </h1>
                <h2>
                  Get 8% Recovery Bonus on Your Next Deposit — 4 Hours Only!
                </h2>
                <div className="promotion-tnc-period">
                  <strong> Daily: </strong>
                  <span
                    style={{ paddingBottom: "5px", display: "inline-block" }}
                  >
                    8:00PM - 12:00MN
                  </span>
                  <br />
                  <strong> Promo Period: </strong>
                  <span>Nov 10, 2025 - Dec 10, 2025 (GMT + 8)</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {isLoggedIn && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      type="button"
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsDepositOpen(true)}
                    >
                      Deposit Now
                    </button>
                  </div>
                )}
                <strong> Mechanics: </strong>
                <ol>
                  <li>Deposit ₱250 or more between 8PM–12MN.</li>
                  <li>Lose that same deposit (balance reaches ₱9 or below).</li>
                  <ul className="no-desc-style" style={{ marginBottom: "0px" }}>
                    <strong className="highlight">
                      ✔ Loss can happen anytime (even after 12MN).
                    </strong>
                  </ul>
                  <li>
                    No withdrawals must be made after that 8PM–12MN deposit.
                  </li>
                  <ul className="no-desc-style" style={{ marginBottom: "0px" }}>
                    <strong className="highlight">
                      ✔ Once these conditions are met, you unlock the 8%
                      Recovery Bonus.
                    </strong>
                  </ul>
                </ol>
                <strong>Examples:</strong>
                <ul>
                  <li>Example 1 — Loss after 12MN qualifies</li>
                  <li>Deposit ₱500 at 8:05PM</li>
                  <li>
                    Play until balance becomes ₱9 or below at 12:40MN →
                    Qualified lost 8–12MN deposit
                  </li>
                  <li>
                    <strong className="highlight">
                      Next deposit (anytime, ₱250+): 8% of ₱500 = ₱40 bonus +
                      ₱250 new deposit
                    </strong>
                  </li>
                </ul>
                <ul>
                  <li>Example 2 — Loss during 8–12MN window also qualifies</li>
                  <li>Deposit ₱250 at 8:30PM</li>
                  <li>Lose balance at 8:50PM → Qualified</li>
                  <li>
                    <strong className="highlight">
                      Next deposit at 1am new deposit of ₱250+ plus 8% of ₱250 =
                      ₱20 bonus
                    </strong>
                  </li>
                </ul>
                <ul>
                  <li>Example 3 — Big deposit</li>
                  <li>Deposit ₱10,000 at 8:10PM</li>
                  <li>Lose it at 8:45PM or even at 10PM → Qualified</li>
                  <li>
                    <strong className="highlight">
                      Next deposit: ₱5000 plus 8% of ₱10,000 = ₱800 bonus
                    </strong>
                  </li>
                </ul>
                <strong>Withdrawal Rule</strong>
                <ol>
                  <li>If you withdraw after receiving the bonus:</li>
                  <ul>
                    <li>
                      <strong className="highlight">
                        You must re-qualify by:
                      </strong>
                    </li>
                    <li>Making a new deposit (8PM–12MN)</li>
                    <li>Losing it completely</li>
                    <li>Having no withdrawals afterward</li>
                  </ul>
                </ol>
                <strong> Terms & Conditions: </strong>
                <ul>
                  <li>
                    <p>
                      Only deposits made between 8PM–12MN qualify for the 8%
                      Recovery Bonus.
                    </p>
                  </li>
                  <li>
                    <p>Loss of that deposit can happen anytime.</p>
                  </li>
                  <li>
                    <p>Bonus can be claimed anytime after qualifying.</p>
                  </li>
                  <li>
                    <p>Minimum deposit to qualify and to claim: ₱250</p>
                  </li>
                  <li>Maximum bonus: ₱2,500</li>
                  <li>
                    <p>Valid on all games.</p>
                  </li>
                  <li>
                    <p>Rollover requirement: 1x Deposit + 1x Bonus.</p>
                  </li>
                  <li>
                    <p>
                      FGH reserves the right to modify, suspend, or cancel the
                      promotion at any time.
                    </p>
                  </li>
                </ul>

                {isDepositOpen &&
                  createPortal(
                    <div className="modal-portal">
                      <Deposit
                        onClose={() => setIsDepositOpen(false)}
                        defaultBonusName="New Member Package Bonus"
                      />
                    </div>,
                    document.body
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
